// 判断是否是PC访问
export function isPC() {
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobile = /iphone|ipad|ipod|android|mobile|webos|blackberry|iemobile|opera mini/i.test(userAgent);
  const isWechat = /micromessenger/i.test(userAgent); // 判断微信内置浏览器

  return !isMobile && !isWechat;
}



// WEBPACK FOOTER //
// ./src/utils/device.js